<template>
  <Content class="customer-list">
    <Card>
      <div slot="title">
        <span>用户管理</span>
      </div>

      <Form id="searchForm" :model="formItem" :label-width="80" inline>
        <FormItem label="关键字">
          <Input v-model="formItem.key" placeholder="昵称/手机号" clearable style="width: 150px;" />
        </FormItem>
        <FormItem label="用户状态">
          <Select v-model="formItem.status" clearable placeholder="全部" style="width: 120px;">
            <Option value="">全部</Option>
            <Option value="active">正常</Option>
            <Option value="disabled">禁用</Option>
          </Select>
        </FormItem>
        <FormItem label="用户标签">
          <Select v-model="formItem.tag" clearable placeholder="全部" style="width: 120px;">
            <Option value="">全部</Option>
            <Option value="VIP">VIP用户</Option>
            <Option value="active">活跃用户</Option>
            <Option value="new">新用户</Option>
            <Option value="dormant">沉睡用户</Option>
          </Select>
        </FormItem>
        <FormItem label="注册时间">
          <DatePicker 
            v-model="formItem.dateRange" 
            type="daterange"
            placeholder="选择时间范围"
            style="width: 200px;"
          />
        </FormItem>
        <FormItem :label-width="20">
          <Button type="primary" @click="search">查询</Button>
          <Button style="margin-left: 8px" @click="clear">重置</Button>
        </FormItem>
        <FormItem class="action-buttons-right">
          <Button type="primary" icon="ios-download-outline" @click="exportUsers">导出</Button>
          <Button 
            type="warning" 
            :disabled="selectedUsers.length === 0"
            @click="batchAction"
            style="margin-left: 8px;"
          >
            批量操作
          </Button>
        </FormItem>
      </Form>

      <Table
        :columns="columns"
        :data="tableData"
        :height="tablesHeight"
        border
        @on-selection-change="handleSelectionChange"
      ></Table>
      <Page
        class="table_page_css"
        v-show="total"
        :total="total"
        :current="searchInfo.pageNo"
        :page-size="searchInfo.pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="pageNoChange"
        @on-page-size-change="pageSizeChange"
        show-sizer
        show-elevator
        show-total
      />
    </Card>
  </Content>
</template>
<script>
import { getCustomerList, batchUpdateCustomers, exportCustomers } from '@/api/customer'
export default {
  name: 'Customer',

  data() {
    return {
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          type: 'index',
          width: 60,
          align: 'center',
        },
        {
          title: '用户昵称',
          key: 'nickname',
          minWidth: 160,
          render: (h, params) => {
            const nickname = params.row.nickName || params.row.nickname || '-'
            return h('div', { style: { display: 'flex', alignItems: 'center', gap: '8px' } }, [
              h('Avatar', {
                props: {
                  src: params.row.avatarUrl,
                  icon: 'ios-person',
                  size: 'small'
                }
              }),
              h('span', nickname)
            ])
          }
        },
        {
          title: '手机号',
          key: 'phone',
          minWidth: 140,
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const status = params.row.status || 'active'
            const statusText = status === 'active' || status === '正常' || status === 1 ? '正常' : '禁用'
            return h('Tag', {
              props: { 
                color: (status === 'active' || status === '正常' || status === 1) ? 'success' : 'error',
                size: 'default'
              },
              style: {
                minWidth: '50px',
                textAlign: 'center'
              }
            }, statusText)
          }
        },
        {
          title: '标签',
          key: 'tags',
          minWidth: 160,
          render: (h, params) => {
            const tags = params.row.tags || []
            if (tags.length === 0) return h('span', '-')
            return h('div', tags.map(tag => h('Tag', { props: { color: 'primary', size: 'small' }, style: { marginRight: '4px' } }, tag)))
          }
        },
        {
          title: '订单数',
          key: 'orderCount',
          width: 120,
          align: 'center',
          render: (h, params) => h('span', params.row.orderCount || 0)
        },
        {
          title: '消费金额',
          key: 'totalSpent',
          minWidth: 140,
          align: 'right',
          render: (h, params) => h('span', { style: { color: '#f56c6c' } }, `¥${(params.row.totalSpent || 0).toFixed(2)}`)
        },
        {
          title: '注册时间',
          key: 'create_time',
          minWidth: 200,
          render: (h, params) => h('span', this.formatTime(params.row.create_time))
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                on: { click: () => this.viewDetail(params.row._id) }
              }, '详情')
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      selectedUsers: [],
      searchInfo: {
        pageNo: 1,
        pageSize: 10,
      },
      pageSizeOpts: [10, 20, 50, 100],
      formItem: {
        key: '',
        status: '',
        tag: '',
        dateRange: []
      },
      tablesHeight: 0,
    }
  },
  methods: {
    setTablesHeight() {
      let aH = 0
      let oA = document.getElementById('app')
      let oH = oA.clientHeight || oA.offsetHeight
      let sA = document.getElementById('searchForm')
      let sH = sA.clientHeight || sA.offsetHeight
      aH = oH - sH - 320
      this.tablesHeight = aH
    },

    getList() {
      const params = {
        ...this.searchInfo,
        key: this.formItem.key,
        status: this.formItem.status,
        tag: this.formItem.tag,
        dateRange: this.formItem.dateRange
      }
      
      getCustomerList(params)
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data
            this.tableData = data.data
            this.total = data.total
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },

    search() {
      this.searchInfo.pageNo = 1
      this.getList()
    },

    clear() {
      this.formItem = {
        key: '',
        status: '',
        tag: '',
        dateRange: []
      }
      this.searchInfo.pageNo = 1
      this.getList()
    },

    viewDetail(userId) {
      this.$router.push({
        name: 'customer-detail',
        params: { id: userId }
      })
    },


    handleSelectionChange(selection) {
      this.selectedUsers = selection.map(item => item._id)
    },

    batchAction() {
      if (this.selectedUsers.length === 0) {
        this.$Message.warning('请先选择用户')
        return
      }

      this.$Modal.confirm({
        title: '批量操作',
        render: (h) => {
          return h('div', [
            h('p', `已选择 ${this.selectedUsers.length} 个用户`),
            h('Select', {
              props: { value: 'disable', placeholder: '选择操作' },
              style: { width: '100%', marginTop: '10px' },
              on: {
                'on-change': (val) => { this.batchActionType = val }
              }
            }, [
              h('Option', { props: { value: 'disable' } }, '批量禁用')
            ])
          ])
        },
        onOk: async () => {
          try {
            const res = await batchUpdateCustomers({
              userIds: this.selectedUsers,
              action: 'updateStatus',
              status: this.batchActionType === 'disable' ? 'disabled' : 'active'
            })
            
            if (res.data && (res.data.success || res.data.code === 200)) {
              this.$Message.success('批量操作成功')
              this.selectedUsers = []
              this.getList()
            } else {
              this.$Message.error(res.data?.message || '操作失败')
            }
          } catch (error) {
            this.$Message.error('操作失败')
          }
        }
      })
    },

    async exportUsers() {
      try {
        this.$Message.loading({
          content: '正在导出...',
          duration: 0
        })

        const res = await exportCustomers({
          ...this.formItem,
          format: 'excel'
        })

        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `用户列表_${new Date().toISOString().slice(0, 10)}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)

        this.$Message.destroy()
        this.$Message.success('导出成功')
      } catch (error) {
        this.$Message.destroy()
        this.$Message.error('导出失败')
      }
    },

    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN')
    },

    pageNoChange(current) {
      this.searchInfo.pageNo = current
      this.getList()
    },

    pageSizeChange(val) {
      this.searchInfo.pageNo = 1
      this.searchInfo.pageSize = val
      this.getList()
    },
  },
  mounted() {
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.customer-list {
  .ivu-form-inline .ivu-form-item {
    margin-right: 16px;
    margin-bottom: 16px;
    vertical-align: top;
  }
  
  // 搜索表单布局优化
  #searchForm {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    
    .ivu-form-item {
      display: inline-block;
      margin-bottom: 0;
      
      // 右侧操作按钮靠右对齐
      &.action-buttons-right {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }
}
</style>
